import { styled } from '@mui/material/styles';
import { QTable } from '@kw/quokka-ui';

export const KwTable = styled(QTable)``;
